import React from 'react';
import DistanceTo from '@/components/Resources/DistanceTo/DistanceTo';
import { resourceHelpers } from '@/utils/helpers';
import OpenNow from '@/components/Resources/OpenNow/OpenNow';

const AddressPanel = ({ resource, additionalClass, showOpenNow }) => {
  const openNow = () => {
    if (resource && showOpenNow) {
      return <OpenNow location={resource} />;
    }
    return null;
  };

  const addressBlock = resource.locations && resource.locations.length > 0 && resource.locations[0]?.lat && (
    <div className={additionalClass.addressWrapper}>
      <div className={additionalClass.address}>
        {resourceHelpers.generateAddressBlock({
          location: resource.locations[0],
          layout: 'inline',
          distanceTo: (
            <DistanceTo
              className={additionalClass.distanceTo}
              locationList={resource.locations}
              distance={resource.locations[0].distanceTo}
              text="N miles away"
              showParentheses
            />
          )
        })}
      </div>
    </div>
  );

  return (
    <>
      {addressBlock}
      {openNow()}
    </>
  );
};

export default AddressPanel;
